export function formatFileSize(bytes = 0, filename = "") {
  const kb = 1024;
  const mb = kb * 1024;
  const size = bytes >= mb ? `${(bytes / mb).toFixed(2)}MB` : `${Math.floor(bytes / kb)}kB`;
  const type = filename.includes(".") ? filename.split(".").pop()?.toUpperCase() ?? "" : "";
  return `${type}${type.length ? ", " : ""}${size}`;
}
